import { render, staticRenderFns } from "./modalAsignacion.vue?vue&type=template&id=0a40c205&"
import script from "./modalAsignacion.vue?vue&type=script&lang=js&"
export * from "./modalAsignacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports